import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { showErrorToast } from '../../utils/toast';
import { formatDate } from '../../utils/helper';


const initialState = {
  loans: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPrevPage: false
  },
  loading: false,
  error: null,
  filters: {
    search: '',
    page: 1,
    limit: 10,
    type:'',
    sortBy: 'createdAt',
    sortOrder: 'desc',
    startDate: null,
    endDate: null,
  },
};

export const fetchLoans = createAsyncThunk(
  'loans/fetchLoans',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { filters } = getState().loans;
      console.log(filters)
      const queryParams = new URLSearchParams();
      queryParams.set('page', String(filters.page));
      queryParams.set('limit', String(filters.limit));
      if (filters.type && filters.type !== '') {
        queryParams.set('type', filters.type);
      }
      if (filters.startDate && filters.endDate) {
        queryParams.set('startDate', formatDate(filters.startDate))
        queryParams.set('endDate', formatDate(filters.endDate))
      }
      
     

      const response = await axiosInstance.get(`/loan/loans?${queryParams}`);
      console.log(response.data.data); 
      return response.data.data; 
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch loans';
      showErrorToast(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

const loansSlice = createSlice({
  name: 'loans',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      if ( action.payload.search || action.payload.status) {
        state.filters.page = 1;
      }
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload.loans || []; 
        state.pagination = action.payload.pagination || initialState.pagination; 
      })
      .addCase(fetchLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilter, resetFilters } = loansSlice.actions;
export default loansSlice.reducer;
